import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../../../reducers/types";
import { actions } from "../../../../actions";
import {
  getLocation,
  getLocationCategories,
  getLocationCategoriesLoading,
  getHasLocationAutocompleteError,
  getStayType,
  getVacationRentalsLocation,
} from "../../../../reducer";
import { MobileLocationSearchModal } from "./component";
import { StayTypesEnum } from "redmond";
import { getVacationRentalsLocationCategories } from "../../../../reducer";

const mapDispatchToProps = {
  setLocation: actions.setLocation,
  setLocationAutocompleteError: actions.setLocationAutocompleteError,
  fetchPCLocationAutocomplete: actions.fetchPCLocationAutocomplete,
  fetchVRLocationAutocomplete: actions.fetchVRLocationAutocomplete,
};

const mapStateToProps = (state: IStoreState) => {
  const stayType = getStayType(state);
  const searchLocation =
    stayType === StayTypesEnum.VacationRentals
      ? getVacationRentalsLocation(state)
      : getLocation(state);
  return {
    stayType,
    location: searchLocation,
    rawLocationCategories: getLocationCategories(state),
    rawVacationRentalsLocationCategories: getVacationRentalsLocationCategories(state),
    loading: !!getLocationCategoriesLoading(state),
    hasLocationAutocompleteError: getHasLocationAutocompleteError(state),
  };
};

interface IOwnProps {
  [key: string]: any;
}

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  dispatchProps: typeof mapDispatchToProps,
  ownProps: IOwnProps
) => {
  const isVR = stateProps.stayType === StayTypesEnum.VacationRentals;

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    setLocationSearchString: isVR
      ? dispatchProps.fetchVRLocationAutocomplete
      : dispatchProps.fetchPCLocationAutocomplete,
    locationCategories: isVR
      ? stateProps.rawVacationRentalsLocationCategories
      : stateProps.rawLocationCategories,
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type MobileLocationSearchModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileLocationSearchModal = connector(
  MobileLocationSearchModal
);
